<div class="timing-page-container">
	<!-- Race Info Bar -->
	@if (raceStatus()) {
		<div class="race-info-bar">
			<div class="race-info-item">
				<span class="race-info-label">LAP</span>
				<span class="race-info-value lap-value">{{ raceStatus()?.elapsedLaps | json }}</span>
			</div>
			<div class="race-info-item">
				<span class="race-info-label">ELAPSED</span>
				<span class="race-info-value">{{ timeStatus()?.elapsedTime | timespan }}</span>
			</div>
			<div class="race-info-item">
				<span class="race-info-label">REMAINING</span>
				<span class="race-info-value">{{ timeStatus()?.remainingTime | timespan }}</span>
			</div>
			<div class="race-info-item">
				<span class="race-info-label">TRACK TEMP</span>
				<span class="race-info-value">{{ trackTempDisplay() }}</span>
			</div>
			<div class="race-info-item">
				<span class="race-info-label">WIND SPEED</span>
				<span class="race-info-value">{{ windSpeedDisplay() }}</span>
			</div>
			<div class="race-info-item">
				<span class="race-info-label">WIND DIRECTION</span>
				<span class="race-info-value wind-direction-value">
					<span
						class="wind-direction-arrow"
						[style.transform]="'rotate(' + windDirectionDegrees() + 'deg)'"
						aria-hidden="true"
					>
						↑
					</span>
					{{ windDirectionLabel() }}
				</span>
			</div>
			<div class="race-info-item">
				<span class="race-info-label">LOCAL TIME</span>
				<span class="race-info-value">{{ localTimeDisplay() }}</span>
			</div>
		</div>
	}
	<div class="flex timing-container">
		<vb-lxp-timing-tower-full
			class="grow-1"
			[enableColumnCustomization]="true"
			[activeClass]="'active-tower-item'"
			[selectedClasses]="selectedClasses()"
		></vb-lxp-timing-tower-full>
		@if (visibilitiesService.controlVisibilities().showMapControl) {
			<vb-lxp-panel
				#mapPanel
				[ngClass]="mapPanel.isOpen() ? 'grow-1' : ''"
				[panelKey]="'map'"
				[defaultOpenState]="true"
				[panelClass]="'map-panel'"
				[panelHeaderClass]="'map-panel-header'"
				[panelBodyClass]="'block h-full'"
				[disablePin]="true"
			>
				<div header class="pr-14">
					<span>{{ this.trackTitle() }}</span>
					<button
						class="border-1 border-border-default p-2 rounded ml-2 cursor-pointer hover:bg-surface-container-high"
						(click)="openFullMapPage()"
						target="_blank"
						[title]="'Full Map'"
					>
						<i class="bi bi-arrows-fullscreen"></i>
					</button>
				</div>
				<div body class="h-full">
					<vb-lxp-map
						[showLabels]="false"
						[selectedCarIds]="timingTowerService.activeList()"
					></vb-lxp-map>
				</div>
			</vb-lxp-panel>
		}
	</div>
</div>
